module.exports = __webpack_public_path__ + "static/img/zhinengxunjian.17687b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/honors/zhinengxunjian.jpg
// module id = pxii
// module chunks = 7